import { getHttpService, IHttpService } from 'web_core_library';
import * as Types from './types';

const baseURL = 'https://user.cdn.neuronation.com/nnmce-prod';

export function createGalleryService() {
  let httpService: IHttpService;

  const getEventsJson = () => {
    return httpService.get<Types.IJsonEvent[]>('/mce.json');
  };

  const service = {
    init: () => {
      httpService = getHttpService(baseURL);
    },
    getEventsJson,
  };
  return service;
}

const GalleryService = createGalleryService();
export default GalleryService;
